module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/1_77cb79d0b7a3fda86da8f04e63ce6f61.jpg";